exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toolbar-title[data-v-80abdf8c]{font-family:SFProBold;font-size:20px}.submit-button[data-v-80abdf8c]{color:#fff!important;line-height:1.45!important;font-weight:700!important;font-size:18px!important;text-transform:none!important;-webkit-box-shadow:none!important;box-shadow:none!important;height:56px;background-color:#00ba57!important;text-align:center;vertical-align:middle;padding:0!important;margin:0 5px;border-radius:100px;border:1px solid transparent}.submit-button[data-v-80abdf8c] .v-btn__content{white-space:pre-wrap;padding:0 30px;line-height:1.1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-80abdf8c","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/b2b/profile/ReferralLinkDialog.vue
// module id = i86v
// module chunks = 0